import React, { useState, useEffect } from 'react';
import {
  makeStyles,
  Grid,
  Container,
  TextField,
  ThemeProvider,
  createMuiTheme,
  InputAdornment,
  InputProps,
  IconButton,
  Link,
  Button,
  Input,
} from '@material-ui/core';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { useForm, Form } from '../elements/useForm';
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  item: {
    paddingTop: 20,
    marginBottom: 10,
  },
  btn: {
    display: 'flex',
    justifyContent: 'center',
  },
  margin: {
    margin: theme.spacing[10],
  },
}));

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#22788C',
    },
  },
});


const initialFValues = {
  name: '',
  email: '',
  value: 0,
  date: new Date(),
};

const Donation = () => {

  // const [onApproveMessage, setOnApproveMessage] = useState('');
  const [onErrorMessage, setOnErrorMessage] = useState('');
  const [donationStatus, setDonationStatus] = useState('');
  
 

  const styles = useStyles();

  const onInit = (data, actions) => {
    actions.disable(); //On init, if inputs are not validated, Paypal button is disabled
   
    // if (validate()) {
    //   actions.enable();
    // } else actions.disable();
  };

  //@TODO: Alert customer that donation is received. Paypal has a confirmed donation URL. look into that.
  //would have the transactionId, paymentMethod, 
  //Receipt on our side
  //email being sent to customer, have it sent to PYTF as well

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ('name' in fieldValues){
      temp.name = fieldValues.name.length > 0 ? '' : 'This field is required.';
    }
    // if ('name' in fieldValues && fieldValues.name.length > 0 ){
    //   temp.name = /^[A-Za-z]+$/.test(fieldValues.name) ? '' : 'Name is invalid.';
    // }

    if ('email' in fieldValues) {
      temp.email =
        /$^|.+@.+..+/.test(fieldValues.email) && fieldValues.email.length > 0
          ? ''
          : 'Email is not valid.';
    }

    // if ('email' in fieldValues){
    //   temp.email = /$^|.+@.+..+/.test(fieldValues.email) ? '' : 'Email is not valid.'
    // }

    if ('value' in fieldValues)
      temp.value =
        fieldValues.value >= 5 && fieldValues.value.length > 0
          ? ''
          : 'Minimum $5 donation.';
    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == '');
    //returns a boolean, if every value of this object is an empty string "", that means the validation pased. If this is true, fields are valid.
  };

  //Sets up the transaction
  const createOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: values.value,
            breakdown: {
              item_total: {
                currency_code: 'USD',
                value: values.value,
              },
            },
          },
          items: [
            {
              name: 'user donation',
              unit_amount: {
                currency_code: 'USD',
                value: values.value,
              },
              quantity: 1,
              category: 'DONATION',
            },
          ],
        },
      ],
      payer: {
        email_address: values.email,
        name: {
          given_name: values.name,
        },
      },
      order_application_context: {
        return_url: 'payyourtuition.org',
        // user is redirected after successful payment
      },
    });
  };

  //Finalizes the transaction
  const onApprove = (data, actions) => {
    return actions.order
      .capture()
      .then((details) => {
        console.log(details);
        let transaction = details.purchase_units[0].payments.captures[0];
        if (transaction.status == `COMPLETED`) {
          setDonationStatus(`onDonationSuccess`);
        }
        alert(`Transaction ${transaction.status}: Your transaction id is: ${transaction.id}. `);
        // setOnApproveMessage(
        //   `Transaction completed by ${details.payer.name.given_name}`
        // );

      })
      .catch((e) => {
        setDonationStatus(`onDonationFail`);
        console.log(`Error in onApprove: ${e}`);
      }
      );
  };

  const onError = (err) => {
    setOnErrorMessage(err.toString());
    setDonationStatus(`onDonationFail`);
    console.log(err);
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

 

  const handleSubmit = () => {
    // send data to backend
    if (donationStatus == `onDonationSuccess`) {
      axios
        .post('/api/donations', {
          date: values.date,
          email: values.email,
          name: values.name,
          value: values.value,
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const renderSwitchView = (param) => {
    switch (param) {
      case 'onDonationSuccess':
        return <div>
          <Grid container alignItems='center' justify='center' spacing={2}>
            <Grid item>
              <h2>
                {'  '}Thank <span className='text-color-secondary'>You</span>
              </h2>
              <p>Your generous <span className='text-color-secondary'>${values.value}</span> donation will help us serve underserved communities.</p>
              <p>Please check your email for a full detail of your receipt.</p>
            </Grid>
          </Grid>
        </div>
      case 'onDonationFail':
        return <div>
          <Grid container alignItems='center' justify='center' spacing={2}>
            <Grid item>
              <h2>
                {'  '}Oops...
              </h2>
              <p>Something went wrong. We haven't received your donation. Please refresh the page and try again.</p>
            </Grid>
          </Grid></div>
      default:
        return <div>
          <Grid container alignItems='center' justify='center' spacing={2}>
            <Grid item>
              <h2>
                {'  '}Donate <span className='text-color-secondary'>below</span>
              </h2>
            </Grid>
            <Grid item xs={12} className={styles.item}>
              <TextField
                fullWidth
                name='email'
                label='Email address'
                value={values.email}
                variant='outlined'
                onChange={handleInputChange} //{(e) => setEmail(e.target.value)}
                required
                placeholder='johndoe@example.com'
                error={errors.email ? true : false}
              />
              {errors.email && (
                <div style={{ color: 'red', fontSize: '12px' }}>
                  {errors.email}
                </div>
              )}
            </Grid>
            <Grid item xs={12} className={styles.item}>
              <TextField
                fullWidth
                variant='outlined'
                label='Full Name'
                name='name'
                value={values.name}
                onChange={handleInputChange}
                required
                // onClick={setNameChange(true)}
                placeholder='John Doe'
                error={errors.name ? true : false}
              />
              {errors.name && (
                <div style={{ color: 'red', fontSize: '12px' }}>
                  {errors.name}
                </div>
              )}
            </Grid>
            <Grid item xs={12} className={styles.item}>
              <TextField
                fullWidth
                name='value'
                label='Amount'
                type='number'
                InputProps={{
                  inputProps: {
                    min: 5,
                  },
                }}
                value={values.value}
                placeholder='5'
                onChange={handleInputChange}
                required
                variant='outlined'
                error={errors.value ? true : false}
              />
              {errors.value && (
                <div style={{ color: 'red', fontSize: '12px' }}>
                  {errors.value}
                </div>
              )}
            </Grid>

            <Grid item xs={12} className={styles.btn}>
              <PayPalButtons
                type='submit'
                style={{
                  layout: 'horizontal',
                  color: 'white',
                  label: 'donate',
                  height: 40,
                }}
                forceReRender={[values.value]}
                onApprove={onApprove}
                createOrder={createOrder}
                onError={onError}
                onClick={handleSubmit}
              onInit={onInit}
              />
            </Grid>
          </Grid>
        </div>
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Container className={styles.root}>
        {renderSwitchView(donationStatus)}
      </Container>
    </ThemeProvider>
  );
};

export default Donation;

